import { ADS_FEED_TYPE, MEMBERSHIP_ADVERT_TYPE, REGULAR_POST_TYPE } from '../../constants/FeedConstants'

import FeedAdvert from '../FeedAdvert'
import MembershipAdvert from '../MembershipAdvert'
import { InspirationItem } from './InspirationItem'

export const FeedTileResolver = ({ adCode, priority, tile, refFn, location, likesObj, savedList, lazyLoad }) => {
  switch (tile.tileType) {
    case REGULAR_POST_TYPE:
      return <InspirationItem priority={priority} hideActionButton refFn={refFn} location={location} likesObj={likesObj} savedList={savedList} lazyLoad={lazyLoad} {...tile} />
    case MEMBERSHIP_ADVERT_TYPE:
      return <MembershipAdvert location={location} />
    case ADS_FEED_TYPE:
      return <FeedAdvert adCode={adCode} location={location} imageIndex={tile.imageIndex} aiTitle={tile.aiTitle} />
    default:
      return null
  }
}
